/*
 * @Author: HuXiangYu
 * @Date: 2022-10-19 09:41:05
 * @Last Modified by: HuXiangYu
 * @Last Modified time: 2023-06-09 09:28:00
 */

// 导入组件，组件必须声明 name
import AceFormRender from './src/components/Form'
import AceFlowFormRender from './src/components/FlowForm'
// 为组件添加 install 方法，用于按需引入
AceFormRender.install = function(Vue) {
	Vue.component(AceFormRender.name, AceFormRender)
}
AceFlowFormRender.install = function(Vue) {
	Vue.component(AceFlowFormRender.name, AceFlowFormRender)
}

export { AceFormRender, AceFlowFormRender }
